import { useEffect, useState } from 'react';
import { AUTH_HINT_EVENT, hasInterviewAuthHint } from './keycloak';

export function useInterviewAuthHint(): boolean {
  const [value, setValue] = useState<boolean>(() => hasInterviewAuthHint());

  useEffect(() => {
    const sync = () => setValue(hasInterviewAuthHint());
    window.addEventListener(AUTH_HINT_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(AUTH_HINT_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return value;
}
